export const T = {
  bg:       "#1a2228",
  bgPanel:  "#222d33",
  bgCard:   "#2a363d",
  bgInput:  "#1e2b31",
  border:   "#36454F",
  borderHi: "#4a5f6b",
  accent:   "#36454F",
  accentHi: "#4a5f6b",
  accentLt: "#6b8a96",
  text:     "#f0f4f5",
  textSub:  "#8faab4",
  textMute: "#3d5560",
  yellow:   "#f59e0b",
  green:    "#22c55e",
  red:      "#ef4444",
  blue:     "#6366f1",
  blueLt:   "#818cf8",
};

export const FONTS = [
  "Inter","Roboto","Poppins","Montserrat","Oswald","Playfair Display","Lato","Raleway","Nunito","DM Sans","Space Grotesk","Syne",
  "Arial","Helvetica","Georgia","Times New Roman","Courier New","Verdana","Trebuchet MS",
  "Source Sans Pro","Quicksand","Fredoka","Work Sans","Barlow","IBM Plex Sans","Muli","Ubuntu",
  "Fira Sans","Cabin","Mulish","Bitter","Merriweather","Crimson Text","EB Garamond"
];
export const LEAF_TYPES = ["text","image","button","input","qr","clock","ticker","googleMap","video","youtube","checkbox","divider","table","slider","quiz","model3d","confetti","html","carousel","productList","pdfViewer","keyboard"];
export const ICON = { text:"T", image:"⬚", button:"▣", input:"▤", qr:"⠿", clock:"◷", ticker:"≡", googleMap:"🗺", video:"▶", youtube:"▶", checkbox:"☑", divider:"—", table:"⊞", slider:"◫", quiz:"❓", model3d:"⬢", confetti:"🎉", html:"</>", carousel:"⇆", productList:"🛍", pdfViewer:"📖", keyboard:"⌨", group:"⬡" };
export const genId = (p="id") => `${p}-${Date.now()}-${Math.floor(Math.random()*99999)}`;

export const defaultListFnConfig = () => ({
  enabled: false,
  sortEnabled: false,
  sortKey: "",
  sortDirection: "asc",
  sortType: "auto",
  filterEnabled: false,
  filterKey: "",
  filterMode: "contains",
  filterValueSource: "static",
  filterValue: "",
  filterVarName: "",
  filterCaseSensitive: false,
  customEnabled: false,
  customTransform: "",
});